<template>
 <main class="dn-margin-end">
    <img class="card-img-top" :src="imgsrc" >
  </main>
</template>

<script>
export default {
  name: 'EndPage',
  data () {
    return {
      imgsrc: ""
    }
  },
  created () {
    const toPage = this.$route.query.toPage || '';
    const imageMap = {
      tdend: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E6%B0%B4%E7%AE%B1%E7%81%B5%E6%82%A6%E7%89%88/endpage.png',
      winend: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/winix/%E5%9B%BE%E7%89%87/%E5%AE%89%E8%A3%85%E5%AE%8C%E6%88%90.png',
      nixend: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/nix2/%E5%AE%89%E8%A3%85%E5%AE%8C%E6%88%90%E6%B5%B7%E6%8A%A5.png',
      dwmend: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%8F%8C%E8%88%B1%E4%BA%91%E9%95%9C%E7%89%88/250527-%E5%AE%89%E8%A3%85%E5%AE%8C%E6%88%90%E6%B5%B7%E6%8A%A5.png',
      dgmend: 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%8F%8C%E8%88%B1%E4%BA%91%E9%95%9C%E7%89%88/250527-%E5%AE%89%E8%A3%85%E5%AE%8C%E6%88%90%E6%B5%B7%E6%8A%A5.png'
    };
    this.imgsrc = imageMap[toPage] || 'https://dn-resource-a.obs.cn-south-1.myhuaweicloud.com/%E5%85%AC%E5%85%B1%E5%9B%BE%E7%89%87/%E5%AE%89%E8%A3%85%E5%AE%8C%E6%88%90.png';
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EndPage.vue